import React, { ReactNode } from "react";
import "./Popover.scss";
import { Button } from "../Button/Button";

interface IProps {
    title: string;
    children: ReactNode | ReactNode[];
    show?: boolean;
    onClose?: () => void;
}

export function Popover(props: IProps) {
    let show = props.show === undefined ? true : props.show;
    const canClose = !!props.onClose;
    return (
        <div className={`popover-wrapper ${show ? 'show' : ''}`}>
            <div className="popover">
                <h1>{props.title}</h1>
                <div className="popover-contents">
                    {props.children}
                </div>
                {canClose ? <Button className={'close-button'} onClick={props.onClose}>&times;</Button> : null}
            </div>
        </div>
    )
}
